<template>
  <div class="part2-main-task">
    <div class="task-header">
      <div class="task-avatar btns" @click="showTitle"></div>
      <div class="task-content">
        <div>
          <span class="task-content-title"
            >{{ langData.myPoints }}{{ lotteryAndTaskState.totalScore }}</span
          >
          <span class="task-content-detail btns" @click="showScoreDetail">{{
            langData.viewPointDetail
          }}</span>
        </div>
        <div>
          <span class="task-content-title title-text"
            >{{ langData.currentTitle
            }}<span
              class="task-content-main"
              :class="`${curLang} level-${realScoreLevel}`"
              :style="`color: ${scoreName[realScoreLevel].color}`"
              >{{ scoreName[realScoreLevel].title }}</span
            ></span
          >
        </div>
        <div class="scorc-progress-container">
          <div class="scorc-progress">
            <i
              class="scorc-progress-icon"
              :style="{ width: `${realScoreProgress * 100}%` }"
            ></i>
            <i
              class="score-point"
              :class="{ active: realScoreLevel >= 50 }"
              style="left: 25%"
              ><span>50</span></i
            >
            <i
              class="score-point"
              :class="{ active: realScoreLevel >= 100 }"
              style="left: 50%"
              ><span> 100</span></i
            >
            <i
              class="score-point"
              :class="{ active: realScoreLevel >= 300 }"
              style="left: 80%"
              ><span>300</span></i
            >
          </div>
        </div>
      </div>
    </div>
    <div class="task-list">
      <div
        class="task-list-item"
        v-for="(item, index) in taskList"
        :key="item.key"
        :class="{
          finish: isShowFinish(item),
          end: lotteryAndTaskState.isEnd,
        }"
      >
        <i class="task-list-item-icon">{{ index + 1 }}</i>
        <div class="task-list-item-content">
          <div class="task-list-item-content-title" :class="curLang">
            {{ langData[item.titleKey] }}
          </div>
          <div class="task-list-item-content-descript">
            {{ getCurDescript(item) }}
          </div>
        </div>
        <div class="task-btn btns" @click="handleTaskBtn(item)">
          {{ taskBtnText(item) }}
        </div>
      </div>
    </div>
    <div class="task-footer">
      <div class="task-rule" @click="showRule">
        {{ langData.taskRuleBtn }}<i class="task-footer-icon"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, reactive, computed, ref } from "vue";
import { taskText } from "@config";
import { UgcTab } from "../typings";
import LanguageHook from "@/hooks/language";

const { langData, curLang } = LanguageHook();

const lotteryAndTaskState = inject("lotteryAndTaskState", reactive({}));
const v3PopupState = inject("v3PopupState", reactive({}));
const checkLogin = inject("checkLogin");
const submitTask = inject("submitTask");
const gotoLogin = inject("gotoLogin");
const isLogin = inject("isLogin");
const activeUgcTab = inject("activeUgcTab", ref(UgcTab.UgcTypeMyROMemory));
const goUgcList = inject("goUgcList");
const goCenter = inject("goCenter");
const showFeedbackPopup = inject("showFeedbackPopup");
const initActivity = inject("initActivity");
const showTipMessage = inject("showTipMessage");

const canClick = ref(true);

const scoreName = computed(() => ({
  0: { title: langData.scoreTitleNone, color: "" },
  50: { title: langData.scoreTitleLv1, color: "" },
  100: { title: langData.scoreTitleLv2, color: "#cc5a00" },
  300: { title: langData.scoreTitleLv3, color: "#cd176c" },
}));

const taskList = computed(() => {
  return taskText.map((item) => {
    return {
      ...item,
      state: lotteryAndTaskState[item.key].state || 0,
      progress: lotteryAndTaskState[item.key].progress || "",
    };
  });
});

const realScoreLevel = computed(() => {
  if (lotteryAndTaskState.historyScore < 50) return 0;
  if (lotteryAndTaskState.historyScore < 100) return 50;
  if (lotteryAndTaskState.historyScore < 300) return 100;
  return 300;
});

const realScoreProgress = computed(() => {
  const score = lotteryAndTaskState.historyScore;
  if (score > 350) return 1;
  if (score <= 50) return (score * 0.25) / 0.5 / 100;
  if (score > 50 && score <= 100)
    return (25 + ((score - 50) * 0.25) / 0.5) / 100;
  if (score > 100 && score <= 300)
    return (50 + ((score - 100) * 0.3) / 2) / 100;
  if (score > 300 && score <= 350)
    return (80 + ((score - 300) * 0.2) / 0.5) / 100;
});

const showTitle = () => {
  lotteryAndTaskState.titlePopup.title =
    scoreName.value[realScoreLevel.value].title;
  lotteryAndTaskState.titlePopup.color =
    scoreName.value[realScoreLevel.value].color;
  v3PopupState.titlePopupState = true;
  window.activityDataLayer.push({
    eventName: "show_popup",
    eventType: "称号弹窗",
    aid: window.activity_name,
    gameId: window.game_id,
  });
};

const getCurDescript = (item) => {
  const desc = langData[item.descriptKey] || "";
  if (item.progress !== void 0) {
    return desc.replace("{n}", item.progress || 0);
  }
  return desc;
};

const isShowFinish = (config) => {
  if (
    config.state === 2 &&
    (config.key == "joinLine" ||
      config.key == "joinYtb" ||
      config.key == "joinDc" ||
      config.key == "joinFb" ||
      config.key == "dailyLogin" ||
      config.key == "downloadGame")
  ) {
    return true;
  }
  return false;
};

const taskBtnText = computed(() => {
  return (item) => {
    if (lotteryAndTaskState.isEnd) return langData.taskBtnEnded;
    if (isShowFinish(item)) return langData.taskBtnFinished;
    return langData.taskBtnGo;
  };
});

const showScoreDetail = () => {
  if (!checkLogin()) return;
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "积分明细",
    eventReason: "首页",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  window.activityDataLayer.push({
    eventName: "show_popup",
    eventType: "积分明细",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  v3PopupState.scoreDetailPopupState = true;
};

const handleTaskBtn = async (item) => {
  if (item.login && !isLogin.value) {
    gotoLogin();
    return;
  }
  if (!checkLogin()) return;
  if (isShowFinish(item)) return;
  if (!canClick.value) return;
  canClick.value = false;
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "任务按钮",
    eventReason: "首页",
    eventValue: item.key,
    aid: window.activity_name,
    gameId: window.game_id,
  });
  if (item.callbackKey) {
    submitTask(item.callbackKey).then(() => {
      initActivity();
    });
  }
  if (item.redirectUrl) {
    let curLink =
      item.key == "downloadGame"
        ? window.globalGetGotoLink({ link: item.redirectUrl })
        : item.redirectUrl;
    window.open(curLink, "_blank");
  }
  if (item.ugcTab) {
    activeUgcTab.value = item.ugcTab;
    goUgcList(item.autoOpen);
  }
  if (item.centerTab) goCenter();
  if (item.feedbackPopup) showFeedbackPopup();
  canClick.value = true;
};

const showRule = () => {
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "规则说明",
    eventReason: "首页",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  window.activityDataLayer.push({
    eventName: "show_popup",
    eventType: "规则说明",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  v3PopupState.taskPopupState = true;
};
</script>

<style scoped lang="less"></style>
